import { useContext, useEffect, useState } from 'react';

import { DataContext } from 'providers/data';
import { ParseIcInsurers } from 'utils/parseIcInsurers';
import { ParamsDataPlatformsWithPolicy } from 'utils/typeServices';

import { Box, Typography, Skeleton } from '@mui/material';

import CarouselCars from 'components/views/CarouselCars';
import FadeAnimation from 'components/views/FadeAnimation';
import { ButtonRectangle } from 'components/views/form/Button';
import { ModalSendEmail, ModalSuccess, ModalRedirectedSite, ModalError } from './Modals';

import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';

import { Label } from './styles';

const DuplicatePolicy = () => {
    const [showModalRedirectedSite, setShowModalRedirectedSite] = useState({
        show: false,
        linkInsure: ''
    });
    const [existDetails, setExistDetails] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalSendEmail, setShowModalSendEmail] = useState(false);
    const [selectedPlatformsWithPolicy, setSelectedPlatformsWithPolicy] = useState<ParamsDataPlatformsWithPolicy>();

    const { selectedCar, dataPlatformsWithPolicy, dataPolicyPdfRequest, handleGetPlatformsWithPolicy } = useContext(DataContext);

    const handleDonwloadPdf = (pdfData: string) => {
        if (pdfData) {
            const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, { type: contentType });
                return blob;
            }

            const blob = b64toBlob(pdfData);
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = blobUrl;
            link.setAttribute('download', 'segunda-via-apolice.pdf');
            document.body.appendChild(link);
            link.click();
        }
    }

    const handleViewPolicy = ({ show, linkInsure, insurerId }: { show: boolean, linkInsure: string, insurerId: number }) => {
        setShowModalRedirectedSite({ linkInsure, show });
        // off
        // if ([3290592, 2153846].indexOf(insurerId) >= 0) {
        //     setShowModalRedirectedSite({ linkInsure, show });
        // } else {
        //     setShowModalSendEmail(show);
        // }
    }

    useEffect(() => {
        if (selectedCar) {
            setExistDetails(true);
            if (dataPlatformsWithPolicy && dataPlatformsWithPolicy?.length > 0) {
                const selectedPlatforms = dataPlatformsWithPolicy.find(({ platformId }) => platformId === selectedCar.NR_PLATAFORMA);

                setSelectedPlatformsWithPolicy(selectedPlatforms);
            } else {
                setExistDetails(false);
            }
        } else {
            setExistDetails(false);
        }

        if (typeof dataPlatformsWithPolicy === 'undefined') {
            handleGetPlatformsWithPolicy({ token: localStorage.getItem('token')! });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, dataPlatformsWithPolicy]);

    // useEffect(() => {
    //     if (showModalSendEmail) {
    //         setShowModalSendEmail(false);

    //         if (dataPolicyPdfRequest) {
    //             if (dataPolicyPdfRequest.IsSuccess) {
    //                 setShowModalSuccess(true);
    //                 dataPolicyPdfRequest.Data && handleDonwloadPdf(dataPolicyPdfRequest.Data);
    //             } else if (dataPolicyPdfRequest.Messages.find(({ Description }) => Description === "Seguradora não possui chamada para segunda via de apólice.")) {
    //                 setShowModalRedirectedSite({ linkInsure: selectedPlatformsWithPolicy?.insurerUrl!, show: true });
    //             } else {
    //                 setShowModalError(true);
    //             }

    //             return;
    //         }

    //         if (dataPolicyPdfRequest === false) {
    //             setShowModalError(true);
    //             return;
    //         }
    //     }

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [dataPolicyPdfRequest]);

    return (
        <FadeAnimation>
            <Box>
                <CarouselCars />
                {selectedPlatformsWithPolicy &&
                    <Box marginBottom='2rem'>
                        <Box sx={{ borderTop: '1px solid #D9D9D9', padding: '1.25rem 0' }}>
                            <Typography fontSize='1.125rem' fontWeight={600}>
                                Informações:
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', width: '100%', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'flex-start', 'button': { height: '2.5rem', width: { xs: '100%', md: '14rem' }, fontSize: '.9375rem', marginTop: { xs: '1.5625rem', md: '0' } } }}>
                            <Box sx={{ display: 'grid', width: { xs: '100%', md: 'auto' }, gridTemplateColumns: { xs: 'auto', md: '11rem auto' }, columnGap: '3.75rem', rowGap: '1.25rem' }}>
                                <Box display={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: { xs: '1rem', md: '' } }}>
                                        <Label>
                                            <p className='title'>
                                                Marca
                                            </p>
                                            <p className='description'>
                                                {existDetails ? selectedCar?.MARCA : <Skeleton />}
                                            </p>
                                        </Label>
                                        <Label sx={{ display: { xs: 'block', md: 'none' } }}>
                                            <p className='title'>
                                                Ano
                                            </p>
                                            <p className='description'>
                                                {existDetails ? selectedCar?.MODELO_ANO : <Skeleton />}
                                            </p>
                                        </Label>
                                    </Box>
                                    <Label sx={{ maxWidth: { xs: '100%', md: '8.125rem' }, display: { xs: 'block', md: 'none' } }}>
                                        <p className='title'>
                                            Seguradora
                                        </p>
                                        <Box sx={{ marginTop: '.5rem', 'svg': { maxWidth: '9rem', maxHeight: '4.1rem' } }}>
                                            {ParseIcInsurers(selectedPlatformsWithPolicy.insurerId)}
                                        </Box>
                                    </Label>
                                </Box>
                                <Label sx={{ display: { xs: 'none', md: 'block' } }}>
                                    <p className='title'>
                                        Ano
                                    </p>
                                    <p className='description'>
                                        {existDetails ? selectedCar?.MODELO_ANO : <Skeleton />}
                                    </p>
                                </Label>
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'row-reverse', md: 'row' }, justifyContent: 'space-between' }}>
                                    <Label>
                                        <p className='title'>
                                            Chassi
                                        </p>
                                        <p className='description'>
                                            {existDetails ? selectedCar?.CHASSI : <Skeleton />}
                                        </p>
                                    </Label>
                                    <Label sx={{ display: { xs: 'block', md: 'none' } }}>
                                        <p className='title'>
                                            Modelo
                                        </p>
                                        <p className='description'>
                                            {existDetails ? selectedCar?.MODELO : <Skeleton />}
                                        </p>
                                    </Label>
                                </Box>
                                <Label sx={{ display: { xs: 'none', md: 'block' } }}>
                                    <p className='title'>
                                        Modelo
                                    </p>
                                    <p className='description'>
                                        {existDetails ? selectedCar?.MODELO : <Skeleton />}
                                    </p>
                                </Label>
                            </Box>
                            <Label sx={{ maxWidth: { xs: '100%', md: '8.125rem' }, display: { xs: 'none', md: 'block' } }}>
                                <p className='title'>
                                    Seguradora
                                </p>
                                <Box sx={{
                                    display: 'grid',
                                    marginTop: '.5rem',
                                    maxWidth: '9rem',
                                    maxHeight: '4.1rem',
                                    'svg': {
                                        width: '100%',
                                        height: '100%',
                                    }
                                }}>
                                    {ParseIcInsurers(selectedPlatformsWithPolicy.insurerId)}
                                </Box>
                            </Label>
                            <Box sx={{ paddingTop: { xs: '0', md: '52px' }, width: { xs: '100%', md: 'auto' } }}>
                                {(!selectedCar?.FL_ICS_LIGHT && !selectedCar?.FL_ITURAN_ONE) &&
                                    <ButtonRectangle name='VISUALIZAR APÓLICE' onClick={() => handleViewPolicy({ show: true, linkInsure: selectedPlatformsWithPolicy.insurerUrl, insurerId: selectedPlatformsWithPolicy.insurerId })} />
                                }
                            </Box>
                        </Box>
                    </Box>
                }

                {((dataPlatformsWithPolicy === false) || !selectedPlatformsWithPolicy) &&
                    <Box sx={{ borderTop: '1px solid #D9D9D9', padding: '3.625rem 0 0' }}>
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', 'svg': { zIndex: '0' } }}>
                            <IcIturinCoverage />
                            <Box sx={{
                                border: '1.5px solid rgba(10, 168, 227, 0.45)',
                                borderRadius: '10px',
                                maxWidth: '21.875rem',
                                padding: '1.25rem 2.81rem 1.25rem',
                                marginTop: '-30px',
                                zIndex: '2',
                                position: 'relative',
                                backgroundColor: 'white',
                                'button': {
                                    width: '100%',
                                    height: '2.5rem',
                                    marginTop: '.875rem'
                                }
                            }}>
                                <Typography fontSize='1.125rem' textAlign='center' fontWeight={700} lineHeight='30px'>
                                    Para o seu serviço Ituran, <br /> não há apólice vigente!
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                }

                <ModalSendEmail openModal={showModalSendEmail} handleClickClosed={() => setShowModalSendEmail(false)} />

                <ModalRedirectedSite openModal={showModalRedirectedSite.show} handleClickClosed={() => setShowModalRedirectedSite({ show: false, linkInsure: '' })} linkInsure={showModalRedirectedSite.linkInsure} />

                <ModalSuccess openModal={showModalSuccess} handleClickClosed={() => setShowModalSuccess(false)} />

                <ModalError openModal={showModalError} handleClickClosed={() => setShowModalError(false)} />
            </Box >
        </FadeAnimation >
    );
}

export default DuplicatePolicy;